export const FETCH_APPLINK = 'state.actions.fetch-applink.FETCH_APPLINK' as const;

export type FetchAppLinkAction = {
	type: typeof FETCH_APPLINK;
};

export const fetchAppLink = (): FetchAppLinkAction => ({
	type: FETCH_APPLINK,
});
